/* eslint-disable */

export default {
  layout_elements: {
    'lg': {
      'p_1': {
        'background_img': '/dynamic/images/b1/default_bg_lg.png',
        'logo': ' ',
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "control", event_actions: 1}
          ]
        },
        '12-lg-1-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'black',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': '0'
          }
        },
        '12-lg-1-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please set the Layout Information using the Edit button, or contact your DGnet ambassador to have them set this system up.',
            'P_fontSize': '2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
            'P_textAlign': 'center'
          }
        },
        '12-lg-1-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/p3s0_large_logo.png',
          }
        }
      },
      'p_3': {
        'background_img': '/dynamic/images/b1/default_bg_md.png',
        'logo': ' ',
        page_props: {
          'P_pageButtonId': '11',
          'P_isPageClickable': '1'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "intro", event_actions: 1}
          ]
        },
        '12-lg-3-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/p3s0_large_logo.png',
          },
        },
        '12-lg-3-49A5137B-2': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Touch Screen to Begin',
            'P_fontSize': '2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        }
      }
    },
    'md': {
      'p_1': {
        'background_img': '/dynamic/images/b1/default_bg_md.png',
        'logo': ' ',
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "control", event_actions: 1}
          ]
        },
        '12-md-1-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'black',
            'P_fontSize': '0.9rem',
            'P_fontWeight': 'bold',
            'P_disabled': '0'
          }
        },
        '12-md-1-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please set the Layout Information using the Edit button, or contact your DGnet ambassador to have them set this system up.',
            'P_fontSize': '2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
            'P_textAlign': 'center'
          }
        },
        '12-md-1-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/p3s0_large_logo.png',
          }
        }
      },
      'p_3': {
        'background_img': '/dynamic/images/b1/default_bg_md.png',
        'logo': ' ',
        page_props: {
          'P_pageButtonId': '11',
          'P_isPageClickable': '1'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "intro", event_actions: 1}
          ]
        },
        '12-md-3-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/p3s0_large_logo.png',
          },
        },
        '12-md-3-49A5137B-2': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Touch Screen to Begin',
            'P_fontSize': '2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        }
      }
    },
    'sm': {
      'p_1': {
        'background_img': '/dynamic/images/b1/default_bg_sm.png',
        'logo': ' ',
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "control", event_actions: 1}
          ]
        },
        '12-sm-1-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'black',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': '0'
          },
        },
        '12-sm-1-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please set the Layout Information using the Edit button, or contact your DGnet ambassador to have them set this system up.',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
            'P_textAlign': 'center'
          }
        },
        '12-sm-1-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/p3s0_large_logo.png',
          },
        },
      },
      'p_3': {
        'background_img': '/dynamic/images/b1/default_bg_sm.png',
        'logo': ' ',
        page_props: {
          'P_pageButtonId': '11',
          'P_isPageClickable': '1'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "intro", event_actions: 1}
          ]
        },
        '12-sm-3-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/p3s0_large_logo.png',
          },
        },
        '12-sm-3-49A5137B-2': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Touch Screen to Begin',
            'P_fontSize': '2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        }
      }
    }
  },
  layout_information: {
    'lg': {
      // page 1 control
      "p_1": {
        'page_uid': 'p_1',
        'page_name': 'control',
        'page_elements': [
          { 'x': 38, 'y': 0, 'w': 8, 'h': 3, 'i': 1, element_id: '12-lg-1-49A5137G-1' },
          { 'x': 10, 'y': 16, 'w': 30, 'h': 5, 'i': 2, element_id: '12-lg-1-49A5137B-1' },
          { 'x': 21, 'y': 3, 'w': 8, 'h': 12, 'i': 3, element_id: '12-lg-1-49A5137D-1' }
        ]
      },
      "p_3": {
        'page_uid': 'p_3',
        'page_name': 'intro',
        'page_elements': [
          { 'x': 16, 'y': 4, 'w': 16, 'h': 22, 'i': 1, element_id: '12-lg-3-49A5137D-1' },
          { 'x': 16, 'y': 28, 'w': 15, 'h': 3, 'i': 2, element_id: '12-lg-3-49A5137B-2' }
        ]
      }
    },
    'md': {
      // page 1 control
      "p_1": {
        'page_uid': 'p_1',
        'page_name': 'control',
        'page_elements': [
          { 'x': 36, 'y': 0, 'w': 10, 'h': 3, 'i': 1, element_id: '12-md-1-49A5137G-1' },
          { 'x': 10, 'y': 22, 'w': 30, 'h': 5, 'i': 2, element_id: '12-md-1-49A5137B-1' },
          { 'x': 19, 'y': 5, 'w': 12, 'h': 12, 'i': 3, element_id: '12-md-1-49A5137D-1' }
        ]
      },
      "p_3": {
        'page_uid': 'p_3',
        'page_name': 'intro',
        'page_elements': [
          { 'x': 16, 'y': 4, 'w': 16, 'h': 22, 'i': 1, element_id: '12-md-3-49A5137D-1' },
          { 'x': 16, 'y': 26, 'w': 18, 'h': 3, 'i': 2, element_id: '12-md-3-49A5137B-2' }
        ]
      }
    },
    'sm': {
      // page 1 control
      'p_1': {
        'page_uid': 'p_1',
        'page_name': 'control',
        'page_elements': [
          { 'x': 11, 'y': 0, 'w': 23, 'h': 2, 'i': 1, element_id: '12-sm-1-49A5137G-1' },
          { 'x': 0, 'y': 18, 'w': 45, 'h': 9, 'i': 2, element_id: '12-sm-1-49A5137B-1' },
          { 'x': 9, 'y': 4, 'w': 26, 'h': 9, 'i': 3, element_id: '12-sm-1-49A5137D-1' }
        ]
      },
      'p_3': {
        'page_uid': 'p_3',
        'page_name': 'intro',
        'page_elements': [
          { 'x': 5, 'y': 4, 'w': 35, 'h': 18, 'i': 1, element_id: '12-sm-3-49A5137D-1' },
          { 'x': 0, 'y': 24, 'w': 47, 'h': 3, 'i': 2, element_id: '12-sm-3-49A5137B-2' }
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/watchdog_includes/default_watchdog_layout.js